import {Layout} from "antd";
import Navbar from "@/components/navigation/navbar";
import Sidebar from "@/components/navigation/sidebar";
import { Outlet, useNavigate } from "react-router";
import {useEffect} from "react";
import {useAppSelector} from "@/store";

const { Content } = Layout;

export default function MainShell() {
    const navigate = useNavigate();
    const {user, loading: authLoading} = useAppSelector(state => state.authentication);

    useEffect(() => {
        if (!user && !authLoading) {
            navigate("/login");
        }
    }, []);

    return (
        <Layout className="app-shell bg-gray-50 transition-all duration-300 lg:overflow-hidden dark:bg-dark-bg">
            <Navbar />

            <Layout className="flex flex-1 flex-col gap-3 px-3 py-3 sm:px-4 md:px-6 lg:min-h-0 lg:flex-row lg:overflow-hidden lg:px-8 xl:px-16">
                <Sidebar />

                <Content
                    className="
                        app-scroll w-full min-w-0 rounded-2xl py-4
                        transition-all duration-300
                        sm:py-5 md:py-6
                        overflow-visible
                        lg:min-h-0 lg:overflow-x-hidden lg:overflow-y-auto
                    "
                >
                    <Outlet />
                </Content>
            </Layout>
        </Layout>
    );
}
